<template lang="pug">
transition(name="modal")
  .modal-wrapper
    .modal-container.status-modal
      button.close(type="button" aria-label="Close")
        span(aria-hidden="true" @click="$emit('closeStatus')") &times;
      .row
        h1 {{lang['Status']}} {{statusSel.device.name}} {{statusSel.createdAt | formatDateTime}}
        .col-xs-6
          table.table.table-condensed.table-hover.status
            tbody
              tr
                th {{lang['Summary']}}
                td(:class="statusSel.summary | statusSummaryClass") {{statusSel.summary}}
              tr
                th {{lang['Operation']}}
                td(:class="statusSel.operation | statusOperationClass") {{statusSel.operation}}
              tr
                th {{lang['Failure']}}
                td(:class="statusSel.failureState | statusFailureStateClass") {{statusSel.failureState}}
              tr
                th {{lang['Power']}}
                td(:class="statusSel.power | statusPowerClass") {{statusSel.power}}
        .col-xs-6(v-if="statusSel.errors")
          h2 {{lang['Errors']}}
          table.table.table-condensed.table-hover.status
            tbody
              tr(v-for="error in statusSel.errors")
                th {{error.error_code}}
                td {{error.error_type}}
                td {{error.status_description}}
</template>

<script>
export default {
  name: 'status-change',
  props: ['lang', 'statusSel'],
  data () {
    return {
    }
  },
  methods: {
    escapeModal (e) {
      if (e.key === 'Escape') {
        this.$emit('closeStatus')
      }
    }
  },
  computed: {
  },
  created () {
    window.addEventListener('keyup', this.escapeModal, false)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.escapeModal, false)
  }
}
</script>
<style lang="sass" scoped>
.status-modal
  position: fixed
  z-index: 999
  margin-top: -20px !important
  margin-left: -20px !important
</style>



// WEBPACK FOOTER //
// src/components/statusChanges/StatusChange.vue